import { useState } from 'react';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardMenu, CardMenuHeader } from '../../cardMenu/components/CardMenu';
import { ContentAssignmentsSearchProvider } from './ContentAssignmentsSearch';
import { UnassignContentList, UnassignContentHeader } from './UnassignContentList';
import { useContentAssignmentsPortals } from '../contentAssignmentsQueries';
import { useHasGate } from '../../accounts/accountsQueries';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { ASSIGN_ANY_CONTENT_GATE, UNASSIGN_LABEL_BY_TYPE } from '../contentAssignmentsConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export { UNASSIGN_LABEL_BY_TYPE };
export const CardMenuUnassignContentOption = ({
  contentId,
  contentType,
  onPortalClick,
  onAssignmentClick,
  onUnassigned
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    hasGate
  } = useHasGate(ASSIGN_ANY_CONTENT_GATE);
  const {
    contentAssignmentsPortalsLoading,
    contentAssignmentsPortals
  } = useContentAssignmentsPortals({
    contentId,
    contentType: contentType,
    skip: !hasGate
  });
  const handleOnOpenChange = e => setIsOpen(e.target.value);
  const handleUnassignClick = () => setIsOpen(true);
  const handleOnUnassigned = (portalId, assignmentId) => {
    setIsOpen(false);
    if (onUnassigned) onUnassigned(portalId, assignmentId);
  };
  if (!hasGate) return null;
  if (!isOpen && (!contentAssignmentsPortals || contentAssignmentsPortals.length === 0)) {
    return null;
  }
  const shouldShowAssignees = !contentAssignmentsPortalsLoading && contentAssignmentsPortals && contentAssignmentsPortals.length > 0;
  const labelMessage = UNASSIGN_LABEL_BY_TYPE[contentType];
  return /*#__PURE__*/_jsx(ContentAssignmentsSearchProvider, {
    children: /*#__PURE__*/_jsx(CardMenu, {
      content: {
        header: /*#__PURE__*/_jsx(CardMenuHeader, {
          children: /*#__PURE__*/_jsx(UnassignContentHeader, {
            labelMessage: labelMessage
          })
        }),
        body: shouldShowAssignees ? /*#__PURE__*/_jsx(UnassignContentList, {
          contentId: contentId,
          contentType: contentType,
          onAssignmentClick: onAssignmentClick,
          onPortalClick: onPortalClick,
          onUnassigned: handleOnUnassigned
        }) : /*#__PURE__*/_jsx(Flex, {
          justifyContent: "center",
          padding: "400",
          children: /*#__PURE__*/_jsx(LoadingSpinner, {
            size: "extra-small"
          })
        })
      },
      onOpenChange: handleOnOpenChange,
      open: isOpen,
      placement: "right bottom",
      children: /*#__PURE__*/_jsx(SideNavItem, {
        "data-test-id": "unassign-content-button",
        iconRight: /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-interactive-default",
          icon: RightIcon,
          paddingInline: "0",
          size: "100"
        }),
        onClick: handleUnassignClick,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: UNASSIGN_LABEL_BY_TYPE[contentType]
        })
      })
    })
  });
};
export default CardMenuUnassignContentOption;